import { component$, Slot, useContextProvider } from "@builder.io/qwik";
import { type RequestHandler, routeLoader$ } from "@builder.io/qwik-city";
import { CoachContext } from "~/contexts/coach";
import { type CoachSelect } from "~/lib/schemas";

// Everything under /coach is dynamic and unique per visitor
export const onGet: RequestHandler = async ({ cacheControl }) => {
  cacheControl({
    public: false,
    maxAge: 0,
    sMaxAge: 0,
    staleWhileRevalidate: 0,
  });
};

export const useCoach = routeLoader$<CoachSelect>(
  async ({ sharedMap, error }) => {
    const coach = sharedMap.get("coach");

    // For the coach routes, we need a valid coach
    if (!coach) {
      throw error(404, "Coach not found");
    }

    return coach;
  },
);

export default component$(() => {
  const coach = useCoach();
  useContextProvider(CoachContext, coach);

  return <Slot />;
});
